import { useState } from 'react'
import SOSOverlay from './SOSOverlay'
import styles from './SOSButton.module.css'

export default function SOSButton() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        className={styles.button}
        onClick={() => setIsOpen(true)}
        aria-label="SOS - Crisis calming help"
      >
        SOS
      </button>

      {isOpen && <SOSOverlay onClose={() => setIsOpen(false)} />}
    </>
  )
}
